// Golf 5 (Frans): toestemming van een ouder voor een kind onder 16 (eigen login, foto) en de
// pagina met de privacyverklaring. Zelfde vorm als golf5App.nl.ts; tutoiement zoals de rest van de
// Franse app. De toestemmingsteksten tellen mee in CHILD_CONSENT_TEXT_HASHES.
export const appChildConsentFr = {
    version: '2026-09-26.1',
    title: 'Consentement pour {name}',
    intro: '{name} a moins de 16 ans. Avant un compte personnel ou une photo, nous demandons d’abord le consentement d’un parent.',
    notNeeded: '{name} a 16 ans ou plus et décide seul d’un compte personnel et d’une photo.',
    login: {
        title: 'Compte personnel',
        text: 'Avec un compte personnel, {name} peut se connecter à l’application sur un téléphone ou un ordinateur. {name} voit alors l’agenda, les tâches, les points et les messages de la famille, mais jamais les consentements, les adresses e-mail ou la santé. AMUMIN B.V. conserve qui a donné le consentement, quand et quel texte tu as lu. Tu peux le retirer à tout moment : le compte cesse aussitôt de fonctionner.',
        check: 'Je suis parent ou tuteur de {name} et je consens à un compte personnel.',
    },
    photo: {
        title: 'Photo comme avatar',
        text: 'Avec ton consentement, tu peux utiliser une photo de {name} au lieu d’une icône. La photo apparaît alors dans l’application et sur le tableau au mur : toutes les personnes dans la pièce avec la tablette la voient. Nous retirons le lieu et les autres données de la photo et ne la partageons avec personne. AMUMIN B.V. conserve qui a donné le consentement, quand et quel texte tu as lu. Tu peux le retirer à tout moment : la photo est aussitôt supprimée.',
        check: 'Je suis parent ou tuteur de {name} et je consens à une photo.',
    },
    ask: 'Donner le consentement',
    give: 'Je consens',
    cancel: 'Pas maintenant',
    withdraw: 'Retirer',
    withdrawConfirm: 'Oui, retirer',
    withdrawLogin: 'Retirer le consentement pour le compte personnel ? Le compte de {name} cesse aussitôt de fonctionner.',
    withdrawPhoto: 'Retirer le consentement pour la photo ? La photo de {name} est aussitôt supprimée.',
    none: 'Pas encore de consentement',
    givenBy: 'Consentement de {name} le {date}',
    givenByYou: 'Ton consentement le {date}',
    givenOn: 'Consentement le {date}',
    hasLogin: '{name} a maintenant un compte personnel.',
    hasPhoto: '{name} a maintenant une photo.',
    given: 'Consentement donné',
    withdrawn: 'Consentement retiré',
    withdrawnLogin: 'Le compte de {name} ne fonctionne plus.',
    withdrawnPhoto: 'La photo de {name} a été supprimée.',
    checkRequired: 'Coche d’abord la case.',
    privacyLink: 'En savoir plus dans la déclaration de confidentialité',
    /** Review g5 sec r2: een kindlogin van vóór 0044 zonder toestemming. */
    loginWithoutConsent: '{name} a déjà un compte sans consentement : donne ton consentement ou désactive le compte.',
    disableLogin: 'Désactiver le compte',
    disableLoginAsk: 'Désactiver le compte de {name} ? Il cesse de fonctionner immédiatement.',
    disableLoginConfirm: 'Oui, désactiver',
    loginDisabled: 'Le compte de {name} est désactivé.',
    /** Gezin: de lijst met zulke kinderen (namen eronder). */
    missingList: 'Ces enfants ont déjà un compte sans consentement : donne ton consentement ou désactive le compte.',
    gateLogin: 'Cette personne a un compte personnel. Un enfant de moins de 16 ans a d’abord besoin du consentement d’un parent : supprime d’abord le compte, modifie ensuite l’âge, puis donne ton consentement.',
    gatePhoto: 'La photo d’un enfant de moins de 16 ans n’est possible qu’avec le consentement d’un parent. Donne d’abord ton consentement ou supprime la photo.',
};
export const appPrivacyStatementFr = {
    title: 'Déclaration de confidentialité',
    back: 'Retour à l’application',
    concept: 'Projet, en cours de vérification juridique',
    version: 'Version {version} · {date}',
    contents: 'Sommaire',
    onlyDutch: 'Cette déclaration n’existe pas encore en français. Tu trouves ci-dessous le texte néerlandais ; tu peux aussi choisir l’anglais.',
    showDutch: 'Nederlands',
    showEnglish: 'English',
    placeholder: 'à compléter',
};
//# sourceMappingURL=golf5App.fr.js.map